export default __webpack_public_path__ + "/assets/header_01.png";